<template lang="html">
  <div class="draft-settings">
    <header>
      <div class="title">
        <h1>{{ draft.name }}</h1>

        <div class="purchased" v-if="hasPurchased">
          <i class="fas fa-check-circle"></i>
          <span>
            Purchased
          </span>
        </div>
      </div>
    </header>

    <router-link
      class="enter-draft"
      :to="`/draft/${id}/room`"
    >
      {{ enterDraftText }} <i class="fas fa-arrow-right"></i>
    </router-link>

    <p>Let's get everything setup for your draft.</p>

    <section class="payment-container">
      <payment-settings />
    </section>

    <section class="myteam-container">
      <my-team-settings />
    </section>

    <section class="invite-container">
      <invite-settings />
    </section>

    <section class="teams-container">
      <team-settings />
    </section>

    <section class="settings-container">
      <main-settings />
    </section>

    <section class="positions-container">
      <position-settings />
    </section>

    <section class="keeper-container">
      <keeper-settings />
    </section>

    <section class="trade-container">
      <trade-settings />
    </section>

    <section v-if="isCommissioner">
      <button
        class="delete small failure"
        @click="deleteDraft"
      >
        Delete
      </button>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import PaymentSettings from './PaymentSettings';
import MyTeamSettings from './MyTeamSettings';
import InviteSettings from './InviteSettings';
import MainSettings from './MainSettings';
import TeamSettings from './TeamSettings';
import PositionSettings from './PositionSettings';
import KeeperSettings from './KeeperSettings';
import TradeSettings from './TradeSettings';

export default {
  components: {
    PaymentSettings,
    MyTeamSettings,
    InviteSettings,
    MainSettings,
    TeamSettings,
    PositionSettings,
    KeeperSettings,
    TradeSettings,
  },

  computed: {
    ...mapState({
      id: ({ route }) => route.params.id,
      draft: ({ draft }) => draft.draft,
      hasPurchased: ({ draft }) => draft.draft.purchased,
    }),

    ...mapGetters({
      isCommissioner: 'draft/isCommissioner',
      isDraftComplete: 'draft/isDraftComplete',
    }),

    enterDraftText() {
      return this.isDraftComplete ? 'View Draft Results' : 'Join Draft Room';
    },
  },

  methods: {
    deleteDraft() {
      this.$confirm({ title: 'Delete Draft', message: 'Are you sure you want to delete this draft?' })
        .then(() => {
          this.$store.dispatch('draft/DELETE_DRAFT', this.id)
            .then(() => {
              this.$toast({ message: 'Draft successfully deleted' });
              this.$router.replace('/dashboard');
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .draft-settings {
    @include container;
  }

  header {
    display: flex;
    align-items: center;

    @media($small) {
      display: block;
    }

    .title {
      flex: 1;
    }
  }

  .enter-draft {
    position: fixed;
    bottom: 0;
    left: 75%;
    right: 0;
    z-index: 1;
    background-color: $primary-color;
    color: $white-color;
    padding: $gp * 1.5;
    text-align: center;
    font-size: px-to-rem(18px);
    font-weight: bold;

    @media($small) {
      left: 0;
    }
  }

  section {
    position: relative;
    padding: $gp * 4 0;

    @media($small) {
      padding: $gp * 2 0;
    }

    h2 {
      margin-top: 0;
    }

    &:not(:last-of-type) {
      border-bottom: 1px solid $gray-color;
    }
  }

  .delete {
    margin-top: $gp;
  }

  .purchased {
    color: $success-color;
    font-size: 20px;
    margin-bottom: $gp;
  }
</style>
